import React from 'react';
import NumberInput from "../commons/NumberInput";
import RadioGroup from "../commons/RadioGroup";
import Select from "../commons/Select";
import SidebarFrame from "./SidebarFrame";
import IconGroup from "../commons/IconGroup";
import CheckboxInput from "../commons/CheckboxInput";

export default class KorpusSettings extends SidebarFrame {

    renderTitle() {
        return I18N("Korpus");
    }

    dachschraege(modell) {
        const werte = APP.metadata.Modellwerte[modell.Name];
        return werte ? werte['dachschraege'] : null;
    }

    get schrank() {
        return APP.arrangement.selectedSchrank;
    }

    set schrank(s) {
        APP.arrangement.selectedSchrank = s;
    }

    renderBody() {

        const arrangement = APP.arrangement;
        const schrank = APP.arrangement.selectedSchrank;

        const {minElementeAnzahl, maxElementeAnzahl} = schrank.getElementGrenzwerte();

        const elemente = _.range(minElementeAnzahl, maxElementeAnzahl+1).map(i=>({value:i, label:i}));

        const schenkelOptions = APP.arrangement.isEckschrank()
            ? [{label:I18N('linker Schenkel'),value:arrangement.schraenke[0]},
               {label:I18N('rechter Schenkel'),value:arrangement.schraenke[1]}]
            : [];

        const einzelschrank = !APP.arrangement.isEckschrank();
        const schenkelWort = einzelschrank ? "Ihr Schrank" : "der Schenkel";

        const modelleList = _.values(APP.metadata.Modelle);
        const modelle = APP.arrangement.changeableModell
            ? modelleList
            : (
                APP.arrangement.isShojituer()
                    ? modelleList.filter(x=>x.Name.startsWith('Shojituerenschrank'))
                    : [APP.arrangement.Modell]
            );

        return (
            <div>

                {modelle.length>1 && (
                    <Select label={I18N("Welche Form soll Ihr Schrank haben?")}
                        value={APP.arrangement.Modell}
                        options={modelle}
                        getLabel={x=>x.Anzeigename}
                        isSameValue={(a,b)=>a.Name==b.Name}
                        onChange={modell=>APP.model.setModell(modell)} />
                )}

                <NumberInput label={I18N(`Wie hoch soll Ihr Schrank sein?`)} value={schrank.size.y} onCommit={value=>APP.model.setHoehe(value, -1)} unit="cm" decimals={0}/>

                {!einzelschrank && (
                <div className="input-wrapper appear">
                    <label>{I18N("Schenkel")}</label>
                    <IconGroup value={this.schrank} options={schenkelOptions}
                               onChange={APP.model.tryWrap(this,value => this.schrank = value)}
                    />
                </div>
                )}

                <NumberInput label={I18N(`Wie breit soll ${schenkelWort} sein?`)} value={schrank.size.x} onCommit={APP.model.tryWrap(this,value=>schrank.setDimension('x', value))} unit="cm" decimals={0}/>
                <NumberInput label={I18N(`Wie tief soll ${schenkelWort} sein?`)} value={schrank.size.z} onCommit={APP.model.tryWrap(this,value=>schrank.setDimension('z', value))} unit="cm"  decimals={0}/>

                {"none"!=schrank.angleSide &&
                <NumberInput label={I18N("Wie hoch ist der Kniestock?")} value={schrank.sizeTop.y} onCommit={value=>APP.model.setKniestock(value)} unit="cm" decimals={0}/>
                }
                {["left", "right"].includes(schrank.angleSide) &&
                <NumberInput label={I18N("Wie breit ist der Schrank oben?")} value={schrank.sizeTop.x} onCommit={value=>APP.model.setBreiteOben(value)} unit="cm" decimals={0}/>
                }
                {"back"==schrank.angleSide &&
                <NumberInput label={I18N("Wie tief ist der Schrank oben?")} value={schrank.sizeTop.z} onCommit={value=>APP.model.setTiefeOben(value)} unit="cm" decimals={0}/>
                }

                <Select label={I18N(`Wieviele Elemente soll ${schenkelWort} haben?`)} value={schrank.elements.length} options={elemente} onChange={APP.model.tryWrap(this,value=>schrank.setNumberOfElements(value))}/>

                {!APP.arrangement.isSchwebetuerOrShoji() && (
                    <div><a className="" onClick={() => APP.uiHandler.sidebar('elemente')}>{I18N("Elemente festlegen")}</a></div>
                )}

            </div>
        )
    }


}

